<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Payment Bank Credit Details Report</v-card-title>
      <v-row class="px-4">
        <v-col cols="3">
          <v-autocomplete
            v-model="payrollPeriod"
            v-validate="'required'"
            label="Payroll Period"
            item-text="payroll_date"
            item-value="id"
            :items="payrollPeriods"
            clearable
            hide-selected
            :error-messages="errors.collect('payrollPeriod')"
            data-vv-name="payrollPeriod"  
            data-vv-as="payroll period"
            return-object
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="selectedCompanies"
            v-validate="'required'"
            label="Payroll Company"
            item-text="name"
            item-value="id"
            :items="companies"
            clearable
            multiple
            hide-selected
            chips
            small-chips
            deletable-chips
            :error-messages="errors.collect('company')"
            data-vv-name="company"  
            data-vv-as="payroll company"
          />
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="progressing" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                :loading="progressing"
                color="primary"
                @click="generate"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row> 
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriods: {
        type: Array,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        progressbar: 0,
        payrollPeriod: null,
        selectedCompanies: [],
      }
    },
    watch: {
      selectedCompanies (newVal) {
        const last = newVal[newVal.length - 1]

        // If last selected is 'ALL', keep only 'ALL'
        if (last === 'ALL' && newVal.length > 1) {
          // Replace with only 'ALL' after current update cycle
          this.$nextTick(() => {
            this.selectedCompanies = ['ALL']
          })
        } else if (newVal.includes('ALL') && newVal.length > 1) {
          // Remove 'ALL' if other company is selected after it
          this.$nextTick(() => {
            this.selectedCompanies = newVal.filter(id => id !== 'ALL')
          })
        }
      },
    },
    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().bankCreditDetail(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            }).then(res => {
              let blob = new Blob([res.data], { type: res.data.type })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', 'Payroll Bank Credit Detail ' + this.payrollPeriod.payroll_date + '.xlsx')
              link.click()

              this.progressing = false
              this.progressbar = 0

              this.$snack({ message: 'Report downloaded successfully' })
            }).catch(() => {
              this.progressing = false

              this.$snack({ color: 'error', message: 'Error! Please contact support' })
            })
          })
      },

      prepareFormData () {
        return {
          payroll_period_id: this.payrollPeriod.id,
          company: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies,
        }
      },
    },
  }
</script>
